import React, {useEffect, Fragment} from 'react';
import {connect} from "react-redux";

import {modifyPageLayoutComponents} from "../PageLayout";
import AgentPageHeader from "./AgentPageHeader";
import AgentPageFooter from "./AgentPageFooter";

const AgentPage = (props) => {

  const {pingPilotAuthToken} = props;

  return (
    <div className="page">
      <iframe src={`https://app.pingpilot.com?token=${pingPilotAuthToken}`}
              data-token={pingPilotAuthToken}
              className="page-iframe"
              border="0"
              allow="microphone; camera; fullscreen; display-capture"/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pingPilotAuthToken} = store.auth;
  return {
    pingPilotAuthToken
  };
};

const mapDispatchToProps = {

};

export default modifyPageLayoutComponents({
  pageHeader: AgentPageHeader,
  content: connect(mapStateToProps, mapDispatchToProps)(AgentPage),
  pageFooter: AgentPageFooter,
});
